<template>
  <img :src="imgPath">
</template>

<script>
import AssetHandler from '@/mixins/assetHandler.js';

export default {
  name: 'asset-image',

  mixins: [
    AssetHandler
  ],

  props: {
    name: String,
    localPath: String,
  },

  computed: {
    config() {
      return this.$parent.$root.config;
    },

    imgPath() {
      return this.hasAssetPath
        ? this.assetPath('images/'+this.name)
        : require(`@/assets/images/${ this.localPath }`);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/asset-image.vue